import React, { ReactElement, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
	MoreVert,
	CheckCircle,
	Error,
	HourglassFull,
	HighlightOff,
	Tune,
	Loop,
	Block
} from '@material-ui/icons';
import {
	makeStyles,
	Button,
	DialogContent,
	DialogActions,
	Dialog,
	TextField,
	Link,
	Popover,
	Tooltip
} from '@material-ui/core';
import './PatientStyle.scss';
import MaterialTable from 'material-table';
import Pagination from '@material-ui/lab/Pagination';
import SearchField from '../../components/search/SearchField';
import {
	getAllPatients,
	sendConsent,
	sendToUsmon,
	sendDocUpload,
	updateNotificationPhone,
	getDocumentAdmin,
	getDocumentsIdForAdminPortal
} from '../../../../shared/src/services/PatientService'
import FilterSelect from './filters/FilterSelect';
import { PatientDocumentItem } from './PatientDocument';
import AppLoader from '../../components/apploader/AppLoader';
import { _snackbarAcknowledgement } from '../../../../shared/src/store/actions/AuthActions';
import { useDispatch } from 'react-redux';
import { axios, CancelTokenSource } from '../../../../shared/src/axios';
import { Document } from '../../../../shared/src/services/service-mappers/BaseMapper';
const useStyles = makeStyles(() => ({
	root: {
		'& .MuiToolbar-regular': {
			minHeight: 0
		}
	},
	button: {
		borderRadius: 8,
		width: '5.1vw',
		height: '2.5vw',
		textAlign: 'center',
		justifyContent: 'center',
		alignItems: 'center',
		textTransform: 'none',
		float: 'right'
	},
	saveButton: {
		borderRadius: 8,
		width: '6.6rem',
		height: '2.84rem;',
		textAlign: 'center',
		justifyContent: 'center',
		alignItems: 'center',
		textTransform: 'none',
		float: 'right',
	},
	dialog: {
		'& .MuiDialog-paperScrollPaper': {
			borderRadius: 8,
			boxShadow: '0 10px 30px 0 rgba(0, 0, 0, 0.05)'
		}
	},
	customTooltip: {
		fontSize: '1rem'
	},
}));

const paginationStyles = makeStyles(theme => ({
	root: {
		'& > *': {
			marginTop: theme.spacing(2)
		}
	}
}));

const consentStatus = [
	'Awaiting confirmation',
	'Pending',
	'Approved',
	'Denied',
	'Failed'
];

const messageStatus = [
	'Pending',
	'Failed',
	'Sent'
];

const documentUploadStatus = [
	'Uploaded',
	'Failed',
];

const documentSentStatus = [
	'Sent',
	'Failed',
];

const Patient = (props: any): JSX.Element => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();
	const pageStyes = paginationStyles();
	const [allPatientsData, setAllPatientsData]: any = useState([])
	const [hoveredRowPID, setHoveredRowPID] = useState<number>(0);
	const [patientDetailsDialog, setPatientDetailsDialog] = useState<{
		RowData: any,
		showDocuments: boolean,
		cards: any[][]
	}>({
		RowData: [],
		showDocuments: false,
		cards: []
	})
	const [editNumberDialog, setEditNumberDialog] = useState({
		showDialog: false,
		phone: "+"
	})
	const [filter, setFilter] = useState<{
		consentStatus: string[];
		smsStatus: string[];
		docUploadStatus: string[];
		docSentStatus: string[];
	}>({
		consentStatus: [],
		smsStatus: [],
		docUploadStatus: [],
		docSentStatus: [],
	});
	const [pageCount, setPageCount] = useState<number>(0);
	const offset = useRef<number>(0);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [filterAnchorEl, setFilterAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const searchTextRef = useRef('');
	const searchTimeout = useRef<number | undefined>(undefined);
	const [loader, setLoader] = useState({
		getDetailsLoader: false,
		getDocumentsLoader: false,
	});
	const [resendConsentDialog, setResendConsentDialog] = useState({
		showDialog: false,
		dialogMessage: ''
	})
	// Define a reference for the cancellation token
	const cancelTokenRef = useRef<CancelTokenSource | null>(null);
	const handleConsentFilterChange = (event: any) => {
		const {
			target: { value },
		} = event;
		const consentStatus_ = typeof value === 'string' ? value.split(',') : value
		setFilter((prevFilter) => ({
			...prevFilter,
			consentStatus: consentStatus_,
		}));
	};
	const handleSMSFilterChange = (event: any) => {
		const {
			target: { value },
		} = event;
		const smsStatus = typeof value === 'string' ? value.split(',') : value;
		setFilter((prevFilter) => ({
			...prevFilter,
			smsStatus,
		}));
	};
	const handleDocUploadFilterChange = (event: any) => {
		const {
			target: { value },
		} = event;
		const docUploadStatus = typeof value === 'string' ? value.split(',') : value
		setFilter((prevFilter) => ({
			...prevFilter,
			docUploadStatus,
		}));
	};
	const handleDocSentFilterChange = (event: any) => {
		const {
			target: { value },
		} = event;
		const docSentStatus = typeof value === 'string' ? value.split(',') : value
		setFilter((prevFilter) => ({
			...prevFilter,
			docSentStatus,
		}));
	};

	const renderActionsClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleActionsClose = () => {
		setAnchorEl(null);
	};
	const handleFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		setFilterAnchorEl(event.currentTarget);
	};
	const handleFilterClose = () => {
		setFilterAnchorEl(null);
	};

	const getDetails = async (offValue: any,
		searchText?: string, consentParams?: string, smsParams?: string,
		docUploadParams?: string, sentToUsmonParams?: string, cancelToken?: CancelTokenSource['token']): Promise<void> => {
		try {
			const SearchText = searchText ? searchText : '';
			const ConsentParams = consentParams ? consentParams : '';
			const SmsParams = smsParams ? smsParams : '';
			const DocUploadParams = docUploadParams ? docUploadParams : '';
			const SentToUsmonParams = sentToUsmonParams ? sentToUsmonParams : '';
			setLoader((prev) => ({ ...prev, getDetailsLoader: true }))
			const patients = await getAllPatients(offValue, SearchText, ConsentParams, SmsParams, DocUploadParams, SentToUsmonParams, cancelToken)
			if (patients && patients?.data) {
				setAllPatientsData(patients.data.rows)
				if (patients.data.count >= 0) {
					setPageCount(Math.ceil(patients.data.count / 8));
				}
			}
		}
		catch (error) {
			const err = error as any;
			if (err) {
				if (err.response && err.response.status === 400) {
					dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, 'error'))
				} else {
					dispatch(_snackbarAcknowledgement(true, err.message, 'error'))
				}
			}
		}
		finally {
			setLoader((prev) => ({ ...prev, getDetailsLoader: false }))
		}
	}

	const getPatientDocuments = async (rowData: any) => {
		try {
			setPatientDetailsDialog((prevDialog) => ({
				...prevDialog,
				RowData: rowData,
				showDocuments: !patientDetailsDialog.showDocuments,
			}));
			setLoader((prev) => ({ ...prev, getDocumentsLoader: true }))
			let allDocuments: Document[] = [];
			// eslint-disable-next-line prefer-const
			let documentIdsResponse = await getDocumentsIdForAdminPortal(rowData.id);

			const documentIds: number[] = documentIdsResponse.data;
			const documentPromises: Promise<any>[] = documentIds.map(id => getDocumentAdmin(rowData.id, id));

			const responses = await Promise.all(documentPromises);
			responses.forEach(response => {
				if (response && response.data) {
					allDocuments = allDocuments.concat(response.data);
				}
			});
			// Group documents by label
			const cardGroupsMap = new Map<string, any[]>();
			allDocuments.forEach((doc) => {
				const key = doc.label;
				if (!cardGroupsMap.has(key)) {
					cardGroupsMap.set(key, []);
				}
				cardGroupsMap.get(key)?.push(doc);
			});
			// Convert Map values to an array
			const AllCards = Array.from(cardGroupsMap.values());

			// Sort each subarray so that 'is_front: true' comes first
			AllCards.forEach((subarray) => {
				subarray.sort((a, b) => (a.is_front === true ? -1 : 1) - (b.is_front === true ? -1 : 1));
			});

			// Sort `AllCards` by length (more items in a subarray should come first):
			AllCards.sort((a, b) => b.length - a.length);
			setPatientDetailsDialog((prevDialog) => ({
				...prevDialog,
				cards: AllCards,
			}));
		}

		catch (error) {
			const err = error as any;
			setPatientDetailsDialog((prevDialog) => ({
				...prevDialog,
				RowData: rowData,
				showDocuments: !patientDetailsDialog.showDocuments,
				cards: [],
			}));
			if (err) {
				if (err.response && err.response.status === 400) {
					dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, 'error'))
				} else {
					dispatch(_snackbarAcknowledgement(true, err.message, 'error'))
				}
			}
		}
		finally {
			setLoader((prev) => ({ ...prev, getDocumentsLoader: false }))
		}
	}

	useEffect(() => {
		getDetails(offset.current);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const getPatientWithAllFilters = () => {
		const searchText = searchTextRef.current;
		const ConsentFilters = filter.consentStatus.map(status => status.toLowerCase()).join();
		const SmsFilters = filter.smsStatus.map(status => (status === 'Failed' ? 'Error' : status).toLowerCase()).join();
		const DocUploadFilters = filter.docUploadStatus.map(status => status === 'Uploaded' ? 1 : 0).join()
		const DocSentFilters = filter.docSentStatus.map(status => status === 'Sent' ? 1 : 0).join()
		getDetails(offset.current, searchText, ConsentFilters, SmsFilters, DocUploadFilters, DocSentFilters);
	}

	const handleFilterSubmit = () => {
		getPatientWithAllFilters()
		handleFilterClose()
	}

	const handleResetFilter = () => {
		const searchText = searchTextRef.current;
		setFilter({
			consentStatus: [],
			smsStatus: [],
			docUploadStatus: [],
			docSentStatus: [],
		})
		getDetails(offset.current, searchText);
		handleFilterClose()
	}

	const handleSearchText = (event: any): void => {
		const searchText = event.target.value;

		// Clear the previous timeout
		if (searchTimeout.current) {
			clearTimeout(searchTimeout.current);
		}

		// Cancel the previous request if it exists
		if (cancelTokenRef.current) {
			cancelTokenRef.current.cancel('Request canceled due to new search input');
		}

		// Set a new timeout
		searchTimeout.current = window.setTimeout(() => {
			searchTextRef.current = searchText;
			offset.current = 0;

			const ConsentFilters = filter.consentStatus
				.map((status) => status.toLowerCase())
				.join();
			const SmsFilters = filter.smsStatus
				.map((status) =>
					status === 'Failed' ? 'Error' : status.toLowerCase()
				)
				.join();
			const DocUploadFilters = filter.docUploadStatus
				.map((status) => (status === 'Uploaded' ? 1 : 0))
				.join();
			const DocSentFilters = filter.docSentStatus
				.map((status) => (status === 'Uploaded' ? 1 : 0))
				.join();

			// Create a new cancellation token for the Axios request
			cancelTokenRef.current = axios.CancelToken.source();
			getDetails(
				offset.current,
				searchText,
				ConsentFilters,
				SmsFilters,
				DocUploadFilters,
				DocSentFilters,
				cancelTokenRef.current.token
			);
		}, 250);
	};

	const handleNumberInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
		let input = event.target.value;
		// Ensure the input starts with '+'
		if (!input.startsWith("+")) {
			input = "+" + input.replace(/\D/g, ""); // Remove non-numeric characters
		} else {
			input = "+" + input.slice(1).replace(/\D/g, ""); // Allow only numbers after +
		}
		// Allow only digits and keep the optional leading '+'
		if (/^\+?[0-9]*$/.test(input)) {
			setEditNumberDialog((prev) => ({
				...prev,
				phone: input
			}));
		}
	};

	const handlePagination = (event: any, page: any) => {
		const searchText = searchTextRef.current;
		offset.current = page - 1;
		const ConsentFilters = filter.consentStatus.map(status => status.toLowerCase()).join();
		const SmsFilters = filter.smsStatus.map(status => (status === 'Failed' ? 'Error' : status).toLowerCase()).join();
		const DocUploadFilters = filter.docUploadStatus.map(status => status === 'Uploaded' ? 1 : 0).join()
		const DocSentFilters = filter.docSentStatus.map(status => status === 'Uploaded' ? 1 : 0).join()
		getDetails(offset.current, searchText, ConsentFilters, SmsFilters, DocUploadFilters, DocSentFilters);
	};

	const onNotificationPhoneUpdate = async () => {
		try {
			await updateNotificationPhone(hoveredRowPID, editNumberDialog.phone)
			dispatch(_snackbarAcknowledgement(true, 'Number updated', t('COMMON.SUCCESS')))
		} catch (error) {
			const err = error as any;
			if (err) {
				if (err.response && err.response.status === 400) {
					dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, 'error'))
				} else {
					dispatch(_snackbarAcknowledgement(true, err.message, 'error'))
				}
			}
		}
		finally {
			setEditNumberDialog({ showDialog: false, phone: "+" })
			setHoveredRowPID(0)
			getPatientWithAllFilters()
		}
	}
	const stylesObject: any = {
		width: '95.7%',
		fontFamily: 'hindGunturMedium',
		fontSize: '0.9vw'
	};

	const optionsObject: any = {
		search: false,
		paging: false,
		header: true,
		showTitle: false,
		sorting: false,
		searchFieldStyle: {
			marginTop: '-5vw',
			width: '22vw',
			height: '3.2vw',
			border: '1px solid #D0D0D0',
			borderRadius: 3,
			backgroundColor: '#FFFFFF',
			paddingLeft: '5%',
			marginLeft: '2%'
		},
		headerStyle: {
			color: '#777B7E',
			fontFamily: 'workSansSemiBold',
			height: '3vw',
			fontSize: '0.75vw',
		},
		detailPanelColumnAlignment: "right"
	};

	const renderActions = (rowData: any) => {
		if (rowData.id === hoveredRowPID) {
			return (
				<div >
					<Button
						id="basic-button"
						aria-controls={open ? 'basic-menu' : undefined}
						aria-haspopup="true"
						aria-expanded={open ? 'true' : undefined}
						onClick={renderActionsClick}
					>
						<MoreVert />
					</Button>
					<Popover
						className="custom-popover"
						id="simple-popover"
						open={Boolean(anchorEl)}
						anchorEl={anchorEl}
						onClose={handleActionsClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right'
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right'
						}}>
						<div className="operations-popup-container">
							<div className="bubble-black" />
							<div className="patient-operations-popup" onClick={handleActionsClose} style={{ display: "flex", flexDirection: "column" }}>
								<div onClick={async () => {
									try {
										await sendConsent(rowData.id, false)
										dispatch(_snackbarAcknowledgement(true, t('PATIENT_PORTAL.CONSENT_SENT'), t('COMMON.SUCCESS')))
									}
									catch (error) {
										const err = error as any;
										if (err && err.response.data.statusText !== 'Warning') {
											if (err.response && err.response.status === 400) {
												dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, t('COMMON.ERRORTEXT')))
											} else {
												dispatch(_snackbarAcknowledgement(true, err.message, t('COMMON.ERRORTEXT')))
											}
										}
										else if (err && err.response.data.statusText === 'Warning') {
											setResendConsentDialog((prev) => ({
												...prev,
												showDialog: true,
												dialogMessage: err.response.data.error.message
											}))
										}
									}
								}}>{t('PATIENT_PORTAL.RESEND_CONSENT')}
								</div>
								<div onClick={async () => {
									try {
										await sendDocUpload(rowData.id)
										dispatch(_snackbarAcknowledgement(true, t('PATIENT_PORTAL.SMS_SENT'), t('COMMON.SUCCESS')))
									}
									catch (error) {
										const err = error as any;
										if (err) {
											if (err.response && err.response.status === 400) {
												dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, t('COMMON.ERRORTEXT')))
											} else {
												dispatch(_snackbarAcknowledgement(true, err.message, t('COMMON.ERRORTEXT')))
											}
										}
									}
								}}>{t('PATIENT_PORTAL.RESEND_SMS')}
								</div>
								<div onClick={async () => {
									try {
										await sendToUsmon(rowData.id)
										dispatch(_snackbarAcknowledgement(true, t('PATIENT_PORTAL.SENT_TO_USMON'), t('COMMON.SUCCESS')))
									}
									catch (error) {
										const err = error as any;
										if (err) {
											if (err.response && err.response.status === 400) {
												dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, t('COMMON.ERRORTEXT')))
											} else {
												dispatch(_snackbarAcknowledgement(true, err.message, t('COMMON.ERRORTEXT')))
											}
										}
									}
								}}>{t('PATIENT_PORTAL.RESEND_TO_USMON')}
								</div>
								<div onClick={() => {
									setEditNumberDialog({ ...editNumberDialog, showDialog: true }), setHoveredRowPID(rowData.id)
									if (rowData.notification_phone != null && rowData.notification_phone) {
										setEditNumberDialog({ showDialog: true, phone: rowData.notification_phone })
									}
								}}>{t('PATIENT_PORTAL.EDIT_PHONE')}
								</div>
							</div>
						</div>
					</Popover>
				</div>
			);
		}
		return null;
	};

	const columnsList: any = [
		{
			title: 'CASE ID',
			field: 'pid',
			cellStyle: {
				width: "7%",
				textAlign: 'left'
			},
			headerStyle: {
				textAlign: 'left',
				width: "7%"
			},
		},
		{
			title: 'PATIENT NAME',
			field: 'name',
			headerStyle: { textAlign: 'left' },
		},
		{
			title: 'HOSPITAL NAME',
			field: 'hospital',
			headerStyle: { textAlign: 'left' },
		},
		{
			title: 'DATE OF SERVICE',
			field: 'dos',
			headerStyle: { textAlign: 'left' },
		},
		{
			title: 'PRODUCT',
			cellStyle: {
				width: "7%",
				textAlign: 'left'
			},
			headerStyle: {
				textAlign: 'left',
				width: "7%"
			},
			render: (rowData: any) => (
				<div >
					{rowData.product === null ? <div className='empty_value'>-</div> : rowData.product}
				</div>
			)
		},
		{
			title: 'PHONE NUMBER',
			cellStyle: {
				width: "7%",
				textAlign: 'left'
			},
			headerStyle: {
				textAlign: 'left',
				width: "7%"
			},
			render: (rowData: any) => (
				<div >
					{rowData.notification_phone === null ? <div className='empty_value'>-</div> : rowData.notification_phone}
				</div>
			)
		},
		{
			title: 'CONSENT STATUS',
			headerStyle: { textAlign: 'left' },
			render: (rowData: any) => (
				<div className='message_column'>
					{Object.keys(rowData.consent_status).length === 0 && <div>-</div>}
					{rowData.consent_status.status === "approved" &&
						<div className='status-text-container'>
							<CheckCircle className='success-icon' /><div className='status-text'>{t('PATIENT_PORTAL.APPROVED')}</div>
						</div>
					}
					{rowData.consent_status.status === "pending" &&
						<div className='status-text-container'>
							<HourglassFull className='pending-icon' /> <div className='status-text'>{t('PATIENT_PORTAL.PENDING')}</div>
						</div>
					}
					{rowData.consent_status.status === "skipped" &&
						<div className='status-text-container'>
							<Block className='pending-icon' /> <div className='status-text'>{t('PATIENT_PORTAL.SKIPPED')}</div>
						</div>
					}
					{rowData.consent_status.status === "awaiting confirmation" &&
						<div className='status-text-container'>
							<HourglassFull className='pending-icon' /> <div className='await-status-text'>{t('PATIENT_PORTAL.AWAITING_CONFIRMATION')}</div>
						</div>
					}
					{rowData.consent_status.status === "denied" &&
						<div className='status-text-container'>
							<HighlightOff color='error' /> <div className='status-text'>{t('PATIENT_PORTAL.DENIED')}</div>
						</div>
					}
					{rowData.consent_status.status === "failed" &&
						<div className='status-text-container'>
							<Error color='error' /> <div className='status-text'>{t('PATIENT_PORTAL.FAILED')}</div>
						</div>
					}
					{rowData.consent_status.message && rowData.consent_status.message !== "" && (
						<div className="reason">
							{rowData.consent_status.message.length >= 30 ? (
								<Tooltip
									title={rowData.consent_status.message}
									placement='right'
									classes={{ tooltip: classes.customTooltip }}>
									<span>
										{t("PATIENT_PORTAL.REASON")}: {rowData.consent_status.message.slice(0, 30)}...
									</span>
								</Tooltip>
							) : (
								<span>
									{t("PATIENT_PORTAL.REASON")}: {rowData.consent_status.message}
								</span>
							)}
						</div>
					)}

				</div>
			)
		},
		{
			title: 'SMS STATUS',
			headerStyle: { textAlign: 'left' },
			render: (rowData: any) => (
				<div className='message_column'>
					{rowData.consent_status.status === "approved"
						&& rowData.sms_status.status === "failed" &&
						<div className='status-text-container'>
							<Error color='error' /> <div className='status-text'>{t('PATIENT_PORTAL.FAILED')} </div>
						</div>
					}
					{rowData.consent_status.status === "approved"
						&& rowData.sms_status.status === "sent" &&
						<div className='status-text-container'>
							<CheckCircle className='success-icon' /> <div className='status-text'>{t('PATIENT_PORTAL.SENT')}</div>
						</div>
					}
					{rowData.consent_status.status === "approved"
						&& rowData.sms_status.status === "pending" &&
						<div className='status-text-container'>
							<HourglassFull className='pending-icon' /> <div className='status-text'>{t('PATIENT_PORTAL.PENDING')}</div>
						</div>
					}
					{rowData.consent_status.status !== "approved" && <div>-</div>}
					<div className='reason'>
						{rowData.sms_status.message &&
							rowData.sms_status.message !== '' && <span>{t('PATIENT_PORTAL.REASON')}: {rowData.sms_status.message}</span>}
					</div>
				</div>
			)
		},
		{
			title: 'DOC UPLOADED STATUS',
			cellStyle: {
				width: "11%",
				textAlign: 'left'
			},
			headerStyle: {
				textAlign: 'left',
				width: "11%"
			},
			field: 'uploaded_doc',
			render: (rowData: any) => (
				<div className='message_column'>
					{rowData.consent_status.status === "approved"
						&& rowData.document_upload_status.status === 'uploaded' ?
						<div className='status-text-container'>
							<CheckCircle className='success-icon' /><div className='status-text'> {t('PATIENT_PORTAL.UPLOADED')}</div>
						</div> : rowData.consent_status.status === "approved"
							&& rowData.document_upload_status.status === 'failed' ?
							<div className='status-text-container'>
								<Error color='error' /><div className='status-text'> {t('PATIENT_PORTAL.FAILED')} </div>
							</div> : "-"
					}
					<div className='reason'>
						{rowData.consent_status.status === "approved"
							&& rowData.document_upload_status.message !== ''
							&& rowData.document_upload_status.message
							&& <span>{t('PATIENT_PORTAL.REASON')}: {rowData.document_upload_status.message}</span>}
					</div>
					{rowData.document_upload_status.uploaded_files && rowData.document_upload_status.uploaded_files.length > 0
						&&
						<div>
							{rowData.document_upload_status.uploaded_files.map(
								(document: string) => <div key={document} className='documents_uploaded'>{document}</div>)
							}
						</div>
					}
				</div>
			)
		},
		{
			title: 'DOC SENT STATUS',
			cellStyle: {
				width: "11%",
				textAlign: 'left'
			},
			headerStyle: {
				textAlign: 'left',
				width: "11%"
			},
			field: 'doc_sent',
			render: (rowData: any) => (
				<div className='message_column'>
					{rowData.consent_status.status === "approved"
						&& rowData.document_usmon_status.status === "uploaded" ?
						<div className='status-text-container'>
							<CheckCircle className='success-icon' /> <div className='status-text'>{t('PATIENT_PORTAL.SENT')}</div>
						</div>
						: rowData.consent_status.status === "approved"
							&& rowData.document_usmon_status.status === "failed" ?
							<div className='status-text-container'>
								<Error color='error' /><div className='status-text'> {t('PATIENT_PORTAL.FAILED')} </div>
							</div> : "-"
					}
					<div className='reason'>
						{rowData.consent_status.status === "approved"
							&& rowData.document_usmon_status.message
							&& rowData.document_usmon_status.message !== ''
							&& <span>{t('PATIENT_PORTAL.REASON')}: {rowData.document_usmon_status.message}</span>}
					</div>
				</div>
			)
		},
		{
			title: '',
			cellStyle: {
				width: "12%",
			},
			headerStyle: {
				textAlign: 'left',
				width: "12%"
			},
			render: (rowData: any) => (
				<div className="table-row"
					onMouseEnter={() => setHoveredRowPID(rowData.id)}>
					<Button
						disabled={rowData.document_upload_status.status !== "uploaded"}
						variant="contained"
						size="large"
						className={[classes.button, 'button'].join(' ')}
						onClick={
							() => getPatientDocuments(rowData)
						}
					>
						<span className="button-text">
							{t('PATIENT_PORTAL.VIEW')}
						</span>
					</Button>
					{renderActions(rowData)}

				</div>
			)
		}
	]

	const renderDocuments = (): ReactElement => {
		return (
			<Dialog
				open={patientDetailsDialog.showDocuments}
				fullWidth
				maxWidth={'md'}
				className={classes.dialog}>
				<DialogContent>
					<div className='documents-dialog-container'>
						<div className='document-header-container'>
							{t('PATIENT_PORTAL.PATIENT_DETAILS')}
						</div>
						<div className='documents-details-container'>
							<div className='document-column-container'>
								<span><span className='column-heading'>{t('PATIENT_PORTAL.PATIENT_ID')}:</span> {patientDetailsDialog.RowData.pid}</span>
								<span><span className='column-heading'>{t('PATIENT_PORTAL.PATIENT_NAME')}: </span>{patientDetailsDialog.RowData.name}</span>
								<span>
									<span className='column-heading'>{t('PATIENT_PORTAL.HOSPITAL_NAME')}:</span> {patientDetailsDialog.RowData.hospital}
								</span>
								<span><span className='column-heading'>{t('PATIENT_PORTAL.DOS')}:</span> {patientDetailsDialog.RowData.dos}</span>
								<span><span className='column-heading'>{t('PATIENT_PORTAL.PRODUCT')}:</span> {patientDetailsDialog.RowData.product}</span>
							</div>
							<div className='document-column-container'>
								<span>
									<span className='column-heading'>{t('PATIENT_PORTAL.CONSENT_STATUS')}: </span>
									{patientDetailsDialog.RowData.consent_status.status?.length > 0 ?
										patientDetailsDialog.RowData.consent_status.status.charAt(0).toUpperCase()
										+ patientDetailsDialog.RowData.consent_status.status.slice(1)+ ' ' : " - "}
									{patientDetailsDialog.RowData.consent_status.message &&
										<span className='reason-column'> ({patientDetailsDialog.RowData.consent_status.message})</span>}
								</span>
								<span>
									<span className='column-heading'>{t('PATIENT_PORTAL.SMS_STATUS')}: </span>
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.sms_status.status?.length > 0 ?
										patientDetailsDialog.RowData.sms_status.status.charAt(0).toUpperCase()
										+ patientDetailsDialog.RowData.sms_status.status.slice(1)+ ' ' : " - "}
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.sms_status.message &&
										<span className='reason-column'>({patientDetailsDialog.RowData.sms_status.message})</span>}
								</span>
								<span>
									<span className='column-heading'>{t('PATIENT_PORTAL.DOC_UPLOAD_STATUS')}: </span>
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.document_upload_status.status?.length > 0 ?
										patientDetailsDialog.RowData.document_upload_status.status.charAt(0).toUpperCase()
										+ patientDetailsDialog.RowData.document_upload_status.status.slice(1)+ ' ' : " - "}
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.sms_status.status === 'sent'
										&& patientDetailsDialog.RowData.document_upload_status.message
										&& <span className='reason-column'>({patientDetailsDialog.RowData.document_upload_status.message})</span>}
								</span>
								<span>
									<span className='column-heading'>{t('PATIENT_PORTAL.DOC_SENT_STATUS')}: </span>
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.document_usmon_status.status?.length > 0 ?
										patientDetailsDialog.RowData.document_usmon_status.status === "uploaded" ?
										t('PATIENT_PORTAL.SENT'): t('PATIENT_PORTAL.FAILED') + ' ' : " - "}
									{patientDetailsDialog.RowData.consent_status.status === 'approved'
										&& patientDetailsDialog.RowData.sms_status.status === 'sent'
										&& patientDetailsDialog.RowData.document_usmon_status.message
										&& <span className='reason-column'>({patientDetailsDialog.RowData.document_usmon_status.message})</span>}
								</span>
							</div>
						</div>
						{loader.getDocumentsLoader ? <AppLoader /> : patientDetailsDialog.RowData.document_upload_status.status === 'uploaded'
							&& patientDetailsDialog.RowData.document_upload_status.message === 'expired' ?
							<div className='document-expired'>{t('PATIENT_PORTAL.EXPIRED')}</div>
							: patientDetailsDialog.cards.length > 0 &&
							<div>
								{patientDetailsDialog.cards.map((i: any) => (
									<div key={i} className='document-images'>
										<div className='document-image-container-row'>
											{i.map((j: any) => (
												<PatientDocumentItem key={j.label} card={j} />
											))}
										</div>
									</div>
								))}
							</div>
						}
					</div>
				</DialogContent>
				<DialogActions className="actions-container">
					<Button
						variant="contained"
						className='button'
						disabled={loader.getDocumentsLoader}
						onClick={() => {
							setPatientDetailsDialog({ ...patientDetailsDialog, showDocuments: !patientDetailsDialog.showDocuments })
						}}
					>
						<span className="button-text">{t('PATIENT_PORTAL.CLOSE')}</span>
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	const renderNumberDialog = (): ReactElement => {
		return (
			<Dialog
				open={editNumberDialog.showDialog}
				// onClose={closeModal}
				maxWidth={'md'}
				className={classes.dialog}>
				<DialogContent>
					<div className='form-container'>
						<div className="title-container">
							<div className="title-view">
								<span className="title-text">
									{t('PATIENT_PORTAL.EDIT_PHONE_NUMBER')}
								</span>
							</div>
							<div className="close-view">
								<Link
									component="button"
									variant="body2"
									onClick={() => { setEditNumberDialog({ showDialog: false, phone: "+" }), setHoveredRowPID(0) }}
								>
									<span className="close-view-text">
										{t('PROCEDUREFLOWHEADER.CLOSE')}
									</span>
								</Link>
							</div>
						</div>
						<div className='text-field-container'>
							<TextField
								className="text-field-input"
								margin="dense"
								variant="outlined"
								id="outlined-textarea"
								type="text"
								fullWidth
								value={editNumberDialog.phone}
								onChange={(event: any): void => { handleNumberInput(event) }}
								inputProps={{
									maxLength: 12,
									pattern: "[0-9]*", // Allows only numbers
									inputMode: "numeric",
								}}
							/>
						</div>
					</div>
				</DialogContent>
				<DialogActions className="actions-container">
					<Button
						variant="contained"
						className={[classes.saveButton, 'button'].join(' ')}
						onClick={() => { onNotificationPhoneUpdate() }}
						disabled={editNumberDialog.phone.length < 12}
					>
						<span className="button-text">{t('TIMESTAMP.SAVEBUTTON')}</span>
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	const renderResendConsentConfirmation = (): ReactElement => {
		return (
			<Dialog
				open={resendConsentDialog.showDialog}
				// onClose={closeModal}
				maxWidth={'md'}
				className={classes.dialog}>
				<DialogContent>
					<div className='form-container'>
						<div className="title-container">
							<div className="consent-confirmation-title-view">
								<span className="title-text">
									{t('PATIENT_PORTAL.DUPLICATE_RECORD')}
								</span>
							</div>
						</div>
						<div className='resend-consent-text-field-container'>
							<span>{resendConsentDialog.dialogMessage}</span>
						</div>
					</div>
				</DialogContent>
				<DialogActions className="actions-container">
					<Button
						variant="contained"
						className={[classes.saveButton, 'button'].join(' ')}
						onClick={async () => {
							try{
								await sendConsent(hoveredRowPID, true);
								dispatch(_snackbarAcknowledgement(true, t('PATIENT_PORTAL.CONSENT_SENT'), t('COMMON.SUCCESS')))
							}
							catch(error) {
								const err = error as any;
										if (err) {
											if (err.response && err.response.status === 400) {
												dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, t('COMMON.ERRORTEXT')))
											} else {
												dispatch(_snackbarAcknowledgement(true, err.message, t('COMMON.ERRORTEXT')))
											}
										}
							}
							finally{
								setResendConsentDialog((prev) => ({ ...prev, showDialog: false }));
							}
						}}
					>
						<span className="button-text">{t('PATIENTINFORMATION.YESBUTTONTEXT')}</span>
					</Button>
					<Button
						variant="contained"
						className={[classes.saveButton, 'button'].join(' ')}
						onClick={() => { setResendConsentDialog((prev) => ({ ...prev, showDialog: false })) }}
					>
						<span className="button-text">{t('PATIENTINFORMATION.NOBUTTONTEXT')}</span>
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	return (
		<div className="patients-wrapper">
			<div className="patients-container">
				<div className="patient-view">
					<div className="patient-text">{t('PATIENT_PORTAL.PATIENTS')}</div>
					<div className="search-main-view">
						<div className='refresh-container'>
							<Tooltip title='Refresh'>
								<Loop
									className="refresh-icon"
									onClick={getPatientWithAllFilters}
								/>
							</Tooltip>
						</div>
						<div className={`search-width ${!patientDetailsDialog.showDocuments && "search-index"} `}>
							<SearchField
								placeholder={t('PATIENT_PORTAL.PLACEHOLDER')}
								onChange={(event: any): void => handleSearchText(event)}
							/>
						</div>
						<div>
							<Button
								className='filter-button'
								id="basic-button"
								aria-controls={open ? 'basic-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								onClick={handleFilter}
							>
								<Tune />
							</Button>
							<Popover
								className="filter-custom-popover"
								id="simple-popover"
								open={Boolean(filterAnchorEl)}
								anchorEl={filterAnchorEl}
								onClose={handleFilterClose}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
							>
								<div className="filter-popup-container">
									<div className="bubble-black" />
									<div className="patient-filter-popup" onClick={handleActionsClose} style={{ display: "flex", flexDirection: "column" }}>
										<FilterSelect
											label={t('PATIENT_PORTAL.CONSENT_STATUS')}
											options={consentStatus}
											value={filter.consentStatus}
											onChange={handleConsentFilterChange}
										/>
										<FilterSelect
											label={t('PATIENT_PORTAL.SMS_STATUS')}
											options={messageStatus}
											value={filter.smsStatus}
											onChange={handleSMSFilterChange}
										/>
										<FilterSelect
											label={t('PATIENT_PORTAL.DOC_UPLOAD_STATUS')}
											options={documentUploadStatus}
											value={filter.docUploadStatus}
											onChange={handleDocUploadFilterChange}
										/>
										<FilterSelect
											label={t('PATIENT_PORTAL.DOC_SENT_STATUS')}
											options={documentSentStatus}
											value={filter.docSentStatus}
											onChange={handleDocSentFilterChange}
										/>
										<div className="filter-button-container">
											<Button variant="contained" color="primary" onClick={handleFilterSubmit} className='apply-filter-button'>
												{t('PATIENT_PORTAL.APPLY_FILTER')}
											</Button>
											<Button variant="contained" onClick={handleResetFilter} className='reset-filter-button'>
												{t('PATIENT_PORTAL.RESET_FILTER')}
											</Button>
										</div>
									</div>
								</div>
							</Popover>
						</div>
					</div>
				</div>

				<div className={classes.root}>
					{loader.getDetailsLoader ? <AppLoader /> : <MaterialTable
						style={{ ...stylesObject }}
						columns={columnsList}
						data={allPatientsData}
						options={optionsObject}
					/>}
				</div>
				{
					pageCount > 0 && (
						<div className={`pagination-view ${loader.getDetailsLoader && 'pagination-display'}`}>
							<div className={pageStyes.root}>
								<Pagination
									count={pageCount}
									shape="rounded"
									onChange={(event: any, page: any) =>
										handlePagination(event, page)
									}
									page={offset.current + 1}
								/>
							</div>
						</div>
					)
				}
			</div >
			{patientDetailsDialog.showDocuments && renderDocuments()}
			{renderNumberDialog()}
			{renderResendConsentConfirmation()}
		</div >
	)
}
export default Patient;